/**
 * 费用模块
 */

import request from '../../request'
import apiDownload from '@/services/api/modules/download'

export default {
  fetchAllFeeType: (data, options = {}) => {
    return request(
      {
        url: '/expense/types',
        method: 'get',
        desc: '获取所有费用类型'
      },
      data,
      options
    )
  },
  fetchUpdateFeeType: (data, options = {}) => {
    return request(
      {
        url: '/expense/type',
        method: 'post',
        desc: '更新费用类型'
      },
      data,
      options
    )
  },
  fetchFeeStrategies: (data, options = {}) => {
    return request(
      {
        url: '/expense/strategies',
        method: 'get',
        desc: '获取财务偏好的枚举已选择'
      },
      data,
      options
    )
  },
  /**
   *
   * @param {code: string} data
   * @param {*} options
   * @returns
   */
  fetchSelectFeeStrategy: (data, options = {}) => {
    return request(
      {
        url: '/expense/strategy',
        method: 'post',
        desc: '选择财务偏好'
      },
      data,
      options
    )
  },

  /**
   * 获取列表 平台sku
   */
  fetchListPlatformSku: (data, options = {}) => {
    return request(
      {
        url: '/expense/platform/sku',
        method: 'post',
        desc: '获取费用列表-平台sku维度的'
      },
      data,
      options
    )
  },
  /**
   * 获取详情 平台sku
   * @param {} data {id}
   * @param {*} options
   * @returns
   */
  fetchDetailPlatformSku: (data, options = {}) => {
    return request(
      {
        url: '/expense/platform/sku',
        method: 'get',
        desc: '获取费用详情-平台sku维度的'
      },
      data,
      options
    )
  },
  /**
   * 批量保存接口 平台sku
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchBatchSavePlatformSku: (data, options = {}) => {
    return request(
      {
        url: '/expense/save/platform/sku',
        method: 'post',
        desc: '批量保存-平台sku维度的'
      },
      data,
      options
    )
  },
  /**
   * 更新单个条目接口 平台sku
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchUpdatePlatformSku: (data, options = {}) => {
    return request(
      {
        url: '/expense/platform/sku',
        method: 'put',
        desc: '更新单个条目接口 平台sku'
      },
      data,
      options
    )
  },
  /**
   * 删除一个条目 平台sku
   * @param {*} data []
   * @param {*} options
   * @returns
   */
  fetchDelItemPlatformSku: (data, options = {}) => {
    return request(
      {
        url: '/expense/del/platform/sku',
        method: 'delete',
        desc: '删除一个条目 平台sku'
      },
      data,
      options
    )
  },
  /**
   * 根据关键词查询平台sku的列表
   * @param {*} data { searchKey: string }
   * @param {*} options
   * @returns
   */
  fetchGroupPlatformSku: (data, options = {}) => {
    return request(
      {
        url: '/expense/group/platform/sku',
        method: 'get',
        desc: '根据关键词查询平台sku的列表'
      },
      data,
      options
    )
  },
  /**
 * 查询订单列表 根据订单号
 * @param {*} code
 * @param {*} data
 * @param {*} options
 * @returns
 */

  fetchListOrderByCode: (searchKey, data, options = {}) => {
    return request(
      {
        url: '/expense/group/order/code',
        method: 'get',
        desc: '查询订单列表 根据订单号'
      },
      {
        searchKey,
        ...data
      },
      options
    )
  },
  /**
   * 获取费用列表 订单维度
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchListOrder: (data, options = {}) => {
    return request(
      {
        url: '/expense/order/code',
        method: 'post',
        desc: '获取费用列表-订单维度'
      },
      data,
      options
    )
  },
  /**
   * 批量新增 订单费用
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchBatchAddOrderFee: (data, options = {}) => {
    return request(
      {
        url: '/expense/save/order/code',
        method: 'post',
        desc: '批量新增 订单费用'
      },
      data,
      options
    )
  },
  /**
   * 更新单个条目接口 订单费用
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchUpdateOrderFee: (data, options = {}) => {
    return request(
      {
        url: '/expense/order/code',
        method: 'put',
        desc: '更新单个条目接口 订单费用'
      },
      data,
      options
    )
  },
  /**
   * 删除多个条目 订单费用
   * @param {*} data []
   * @param {*} options
   * @returns
   */
  fetchDelItemOrderFee: (data, options = {}) => {
    return request(
      {
        url: '/expense/del/order/code',
        method: 'delete',
        desc: '删除一个条目 订单费用'
      },
      data,
      options
    )
  },
  /**
   * 获取费用详情-订单费用
   * @param {*} id
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchDetailOrderFee: (id, data, options = {}) => {
    return request(
      {
        url: '/expense/order/code',
        method: 'get',
        desc: '获取费用详情-订单费用'
      },
      {
        ...data,
        id
      },
      options
    )
  },

  fetchListStore: (data, options = {}) => {
    return request(
      {
        url: '/expense/shop',
        method: 'post',
        desc: '获取费用列表-店铺维度'
      },
      data,
      options
    )
  },
  /**
   * 批量新增 店铺费用
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchBatchAddShopFee: (data, options = {}) => {
    return request(
      {
        url: '/expense/save/shop',
        method: 'post',
        desc: '批量新增 店铺费用'
      },
      data,
      options
    )
  },
  /**
   * 更新单个条目接口 店铺费用
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchUpdateShopFee: (data, options = {}) => {
    return request(
      {
        url: '/expense/shop',
        method: 'put',
        desc: '更新单个条目接口 店铺费用'
      },
      data,
      options
    )
  },
  /**
   * 删除多个条目 店铺费用
   * @param {*} data []
   * @param {*} options
   * @returns
   */
  fetchDelItemShopFee: (data, options = {}) => {
    return request(
      {
        url: '/expense/del/shop',
        method: 'delete',
        desc: '删除多个条目 店铺费用'
      },
      data,
      options
    )
  },
  /**
   * 获取费用详情-店铺费用
   * @param {*} id
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchDetailShopFee: (id, data, options = {}) => {
    return request(
      {
        url: '/expense/shop',
        method: 'get',
        desc: '获取费用详情-店铺费用'
      },
      {
        ...data,
        id
      },
      options
    )
  },

  fetchListSystemSku: (data, options = {}) => {
    return request(
      {
        url: '/expense/system/sku',
        method: 'post',
        desc: '获取费用列表-系统sku维度的'
      },
      data,
      options
    )
  },
  /**
   * 获取费用详情 系统维度
   * @param {*} data {id: string}
   * @param {*} options
   * @returns
   */
  fetchSystemSkuDetail: (id, data, options = {}) => {
    return request(
      {
        url: '/expense/system/sku',
        method: 'get',
        desc: '获取费详情-系统sku维度的'
      },
      {
        ...data,
        id
      },
      options
    )
  },
  /**
   * 更新费用详情 系统维度
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchUpdateSystemSku: (data, options = {}) => {
    return request(
      {
        url: '/expense/system/sku',
        method: 'put',
        desc: '更新费用详情 系统维度'
      },
      {
        ...data
      },
      options
    )
  },
  /**
   * 获取所有货币符号
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchCurrencyCodeList: (data, options = {}) => {
    return request(
      {
        url: '/expense/get/allCurrencyCode',
        method: 'get',
        desc: '获取所有货币符号'
      },
      {
        ...data
      },
      options
    )
  },
  expenseOnLineSharePage: (data, options = {}) => {
    return request(
      {
        url: '/expense/expenseOnLineShare/page',
        method: 'post',
        desc: '财务设置-费用分摊'
      },
      {
        ...data
      },
      options
    )
  },
  expenseOnLineShareUpdate: (data, options = {}) => {
    return request(
      {
        url: '/expense/expenseOnLineShare/update',
        method: 'post',
        desc: '财务设置-费用分摊修改'
      },
      {
        ...data
      },
      options
    )
  },
  sysConfigLogPage: (data, options = {}) => {
    return request(
      {
        url: '/sysConfigLog/page',
        method: 'post',
        desc: '财务设置-费用分摊修改日志'
      },
      {
        ...data
      },
      options
    )
  },
  /**
   * 费用管理-规则配置-列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchListRules: (data, options = {}) => {
    return request(
      {
        url: '/rule/getRules',
        method: 'post',
        desc: '费用管理-规则配置-列表'
      },
      data,
      options
    )
  },
  /**
   * 费用管理-规则配置-保存
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchSaveRules: (data, options = {}) => {
    return request(
      {
        url: '/rule/saveRule',
        method: 'post',
        desc: '费用管理-规则配置-保存'
      },
      data,
      options
    )
  },
  /**
   * 费用管理-规则配置-更新
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchUpdateRules: (data, options = {}) => {
    return request(
      {
        url: '/rule/updateRule',
        method: 'post',
        desc: '费用管理-规则配置-更新'
      },
      data,
      options
    )
  },
  /**
   * 费用管理-规则配置-删除
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchRemoveRules: (data, options = {}) => {
    return request(
      {
        url: '/rule/removeRules',
        method: 'post',
        desc: '费用管理-规则配置-删除'
      },
      data,
      options
    )
  },
  /**
   * 费用管理-选择店铺-根据平台id
   * @param {*} data
   * @param {*} options
   * @returns
   */
  getShopInfoByPlatformId: (data, options = {}) => {
    return request(
      {
        url: '/rule/getShopInfoByPlatformId',
        method: 'get',
        desc: '费用管理-选择店铺-根据平台id'
      },
      data,
      options
    )
  },

  /**
   * 费用管理-规则配置-重算
   * @param {*} data
   * @param {*} options
   * @returns
   */
  ruleRecompute: (data, options = {}) => {
    return request(
      {
        url: '/rule/recompute',
        method: 'post',
        desc: '费用管理-规则配置-重算'
      },
      data,
      options
    )
  },
  /**
   * 费用管理-规则配置-重算记录
   * @param {*} data
   * @param {*} options
   * @returns
   */
  ruleRecomputeRecord: (data, options = {}) => {
    return request(
      {
        url: '/rule/recompute/record',
        method: 'post',
        desc: '费用管理-规则配置-重算记录'
      },
      data,
      options
    )
  },

  downloadFeeMgtPlatformExcel(reqData) {
    // const url = genDirectiveDownloadUrl(`${process.env.VUE_APP_BASE_API}/expense/export/platform/sku`, reqData, true)
    // console.log('即将打开url:', url)
    // window.open(url)
    apiDownload.fetchDownloadPostGeneric('/expense/export/platform/sku', reqData)
  },
  downloadFeeMgtShopExcel(reqData) {
    // const url = genDirectiveDownloadUrl(`${process.env.VUE_APP_BASE_API}/expense/export/shop`, reqData, true)
    // console.log('即将打开url:', url)
    // window.open(url)
    apiDownload.fetchDownloadPostGeneric('/expense/export/shop', reqData)
  },
  downloadFeeMgtOrderExcel(reqData) {
    // const url = genDirectiveDownloadUrl(`${process.env.VUE_APP_BASE_API}/expense/order/code`, reqData, true)
    // console.log('即将打开url:', url)
    // window.open(url)
    apiDownload.fetchDownloadPostGeneric('/expense/export/order/code', reqData)
  },
  fetchNonFbaWarehouseOptions: (data, options = {}) => {
    return request(
      {
        url: '/expense/system/sku/queryNotSetWarehouseInfo',
        method: 'get',
        desc: '获取 仓库可选项, 非FBA仓库'
      },
      data,
      options
    )
  },
  fetchNonFbaWarehouseFeeDetail: (data, options = {}) => {
    return request(
      {
        url: '/expense/system/sku/nonFbaWarehouseFee',
        method: 'get',
        desc: '获取非FBA从库费用详情'
      },
      data,
      options
    )
  },
  fetchWarehouseListSystemSkuRelate: (data, options = {}) => {
    return request(
      {
        url: '/expenseSystemSku/querySystemSkuRelationWarehouse',
        method: 'get',
        desc: '查询系统sku关联的仓库'
      },
      data,
      options
    )
  },
  fetchFixedCostSystemSkuList: (data, options = {}) => {
    return request(
      {
        url: '/expenseSystemSku/querySystemSkuInfoByPage',
        method: 'post',
        desc: '固定成本系统sku的列表'
      },
      data,
      options
    )
  },
  fetchFixedCostSystemSkuRelationSiteInfoList: (data, options = {}) => {
    return request(
      {
        url: '/expenseSystemSku/querySystemSkuRelationNormalInfo',
        method: 'get',
        desc: '固定成本系统sku-关联的站点列表信息'
      },
      data,
      options
    )
  },
  fetchFixedCostSystemSkuRelationSiteInfoAllList: (data, options = {}) => {
    return request(
      {
        url: '/expenseSystemSku/querySystemSkuRelationAllInfo',
        method: 'post',
        desc: '固定成本系统sku-关联的站点列表信息-包含默认'
      },
      data,
      options
    )
  },
  fetchFixedCostSystemSkuUpdate: (data, options = {}) => {
    return request(
      {
        url: '/expenseSystemSku/updateSystemSkuRelationInfo',
        method: 'post',
        desc: '固定成本系统sku-保存(更新)'
      },
      data,
      options
    )
  },

}
